import PublicOfferList from "@components/ui/offer/public-list";

const OfferList = () => <PublicOfferList />;

export default OfferList;